import getForwardContentPlainText from './getForwardContentPlainText';
import Message from 'owa-service/lib/contract/Message';
import { ClientItem, mailStore } from 'owa-mail-store';
import { isNullOrWhiteSpace } from 'owa-string-utils';

const MIN_TEXT_LENGTH = 40;

export default function getQuotedTextLocale(
    item: ClientItem,
    quotedTextLocales: string[],
    targetLocale: string,
    checkCanTranslate: any
): string {
    const messageItem = item as Message;
    let conversationNode = mailStore.conversationNodes.get(messageItem.InternetMessageId);
    if (conversationNode?.hasQuotedText && conversationNode.quotedTextList) {
        if (
            !quotedTextLocales ||
            quotedTextLocales.length <= 0 ||
            conversationNode.quotedTextList.length != quotedTextLocales.length
        ) {
            // There is/are quoted text(s), but we can't determine the language
            return '';
        }

        for (let i = 0; i < quotedTextLocales.length; i++) {
            if (isNullOrWhiteSpace(quotedTextLocales[i])) {
                continue;
            }
            const plainText = getForwardContentPlainText(conversationNode.quotedTextList[i]);
            if (
                plainText &&
                plainText.length >= MIN_TEXT_LENGTH &&
                checkCanTranslate(targetLocale, quotedTextLocales[i])
            ) {
                return quotedTextLocales[i];
            }
        }
    }
    return null;
}
